import { addDays, NO_START, diffDay } from 'ha/helpers/hadate';
import {
  MonthGapLimit,
  NoStartDateMonthLimit,
  DateFlexibility,
} from '../constants';

import { FilterBuilder } from '../Types';

const normalizeStartDate = (startDate?: string): string => {
  if (startDate) {
    return addDays(startDate, DateFlexibility);
  } else {
    // If no start date is given, filter listings that will not be available in
    // the following `NoStartDateMonthLimit` months
    const startDateLimit = new Date();
    startDateLimit.setMonth(startDateLimit.getMonth() + NoStartDateMonthLimit);
    startDateLimit.setDate(0);
    startDateLimit.setHours(0, 0, 0);

    return startDateLimit.toDateString();
  }
};

const gapMinimizeFilter = (startDate?: string): string => {
  if (!startDate) {
    return '';
  }

  // Exclude listings that leave too big of a gap between user startDate and listing available from.
  const minStartDateLimit = new Date(startDate);
  minStartDateLimit.setDate(1);
  minStartDateLimit.setHours(0, 0, 0);
  minStartDateLimit.setMonth(minStartDateLimit.getMonth() - MonthGapLimit);
  const minStartDateLimitTS = minStartDateLimit.getTime() / 1000;
  const noStartDateTS = new Date(NO_START).getTime() / 1000;
  const query = `dateFromTS>=${minStartDateLimitTS}`;

  // include listings which doesn't have a start date only if user searchs with a start date in near future
  if (minStartDateLimit < new Date()) {
    return `(${query} OR dateFromTS=${noStartDateTS})`;
  } else {
    return query;
  }
};

const dateFromFilter = (startDate?: string, endDate?: string): string => {
  const start = Boolean(
    startDate && endDate && diffDay(endDate, startDate) <= 2 * DateFlexibility,
  )
    ? (startDate as string)
    : normalizeStartDate(startDate);
  const startDateTS = new Date(start).getTime() / 1000;
  const noStartDateTS = new Date(NO_START).getTime() / 1000;

  return `(dateFromTS<=${startDateTS} OR dateFromTS=${noStartDateTS})`;
};

const dateFromTSBuilder: FilterBuilder = ({
  startDate,
  endDate,
  advertiserId,
}) => {
  if (!startDate && advertiserId) {
    return '';
  }

  const dateFrom = dateFromFilter(startDate, endDate);
  const gapMinimize = gapMinimizeFilter(startDate);

  return [dateFrom, gapMinimize].filter(Boolean).join(' AND ');
};

export default dateFromTSBuilder;
